// extracted by mini-css-extract-plugin
export var aiStarIcon = "_bh-4";
export var closeButton = "_bh-6";
export var dismissButton = "_bh-3";
export var editImageWithAiContainer = "_bh-8";
export var imageUploadWrapper = "_bh-7";
export var misspelledWord = "_bh-5";
export var spellCheckContainer = "_bh-2";
export var spin = "_bh-1";
export var spinning = "_bh-0";